var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isPosition ? 'fotter position' : 'fotter'},[_vm._v(" Copyright © 2021-2022 福建火柴数据有限公司提供技术支持 ")])}
var staticRenderFns = []

export { render, staticRenderFns }